import type { Signal, ExecutionLog } from '../types/strategy';
import { API_BASE_URL } from '../config';
import { apiFetch } from '../utils/apiFetch';

export const strategyApi = {
  // 전략 신호 조회
  async getSignal(symbol: string, profile?: string): Promise<Signal> {
    const encodedSymbol = encodeURIComponent(symbol);
    const query = profile ? `?profile=${encodeURIComponent(profile)}` : '';
    const response = await apiFetch(`${API_BASE_URL}/api/strategies/signals/${encodedSymbol}${query}`);
    if (!response.ok) {
      const body = await response.text();
      throw new Error(`신호 조회 실패: ${response.status} ${body}`);
    }
    return response.json();
  },

  // 전략 수동 실행
  async executeStrategy(symbol: string): Promise<any> {
    const encodedSymbol = encodeURIComponent(symbol);
    const response = await apiFetch(`${API_BASE_URL}/api/strategies/execute/${encodedSymbol}`, {
      method: 'POST',
    });
    if (!response.ok) throw new Error(`전략 실행 실패: ${response.status}`);
    return response.json();
  },

  // 실행 로그 조회
  async getLogs(limit: number = 50, symbol?: string): Promise<ExecutionLog[]> {
    const params = new URLSearchParams();
    params.append('limit', limit.toString());
    if (symbol) {
      params.append('symbol', symbol);
    }

    const response = await apiFetch(`${API_BASE_URL}/api/strategies/logs?${params.toString()}`);
    if (!response.ok) throw new Error(`로그 조회 실패: ${response.status}`);
    return response.json();
  },
};
